export default {

  setAI(state,val){
    state.AI = val.ID;
  }

}



// WEBPACK FOOTER //
// ./src/Auth/store/mutations.js